<template>
    <div class="fluid" style="font-family: Open Sans, sans-serif">
        <div style="margin-top: 10%;margin-bottom: 5%;">
            <div v-if="!isValidToken" class="justify-content-center row">
                <span v-responsive.lg.xl class="text-center title-cni-invalid-link">{{$t('kyc.used_or_not_valide_title')}}</span>
                <span v-responsive.sm.xs class="text-center title-cni-invalid-link-mobile ml-5 mr-5">{{$t('kyc.used_or_not_valide_title')}}</span>
            </div>
            <div v-else class="justify-content-center row">
                <span v-responsive.lg.xl  class="text-center title-cni">{{$t('kyc.download_title')}}</span>
                <span v-responsive.sm.xs class="text-center title-cni-mobile">{{$t('kyc.download_title')}}</span>
            </div>
        <div v-responsive.lg.xl  v-if="isValidToken" class="form-cni justify-content-center row">
              <div class="container justify-content-center row text-center">
                  <label for="images" id="dropcontainer" class="drop-container">
                    <span class="drop-title">{{$t('kyc.glisser_label')}}</span>
                    <span class="drop-subtitle">{{$t('kyc.or_label')}}</span>
                    <span class="drop-subtitle">{{$t('kyc.selection_file')}}</span>
                    <input class="mb-3" @change="filesChange($event.target.files);fileCount = $event.target.files.length" type="file" id="images" name="fileExcel" accept="image/*,.pdf" required="required">
                  </label>
                 
                </div>
        </div>

         <div v-responsive.sm.xs v-if="isValidToken" class="form-cni justify-content-center row">
              <div class="container justify-content-center row text-center">
                  <label for="images" id="dropcontainer" class="drop-container-mobile">
                    <span class="drop-title">{{$t('kyc.glisser_label')}}</span>
                    <span class="drop-subtitle">{{$t('kyc.or_label')}}</span>
                    <span class="drop-subtitle">{{$t('kyc.selection_file')}}</span>
                    <input class="mb-3" @change="filesChange($event.target.files);fileCount = $event.target.files.length" type="file" id="images" name="fileExcel" accept="image/*,.pdf" required="required">
                  </label>
                 
                </div>
        </div>
        </div>

        <div v-if="dialogLoadingFile" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('kyc.send_file_label')}}</span>
      </div>
      <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
    </div>
</template>

<script>
import Api from '../../services/Api'
import LoginForm from './Login.vue'
    export default {
        name: "set_password",
        components: {
            LoginForm
        },
        data() {
            return {
                showLoginForm : false,
                dialogLoadingFile : false,
                newPasswordMailRequest : null,
                user_requester_email: null,
                email: null,
                isValidToken: false,
                showPassword: false,
                showConfirmation: false,
                tokenUserData: null,
                notifications: false,
                password_new: null,
                confirmation: null,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                email: null,
                ServerRep: null,
                file:null
            }
        },
        methods: {
            filesChange(fileList) {
              if (!fileList.length) return;
                this.file = fileList[0];

                // Check if file is valid image or PDF
                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
                const maxSize = 5 * 1024 * 1024; // 5MB in bytes

                if (!allowedTypes.includes(this.file.type)) {
                    this.$toasted.show('Seuls les fichiers images (JPG, PNG, GIF) et PDF sont acceptés.', this.ToastTabError);
                    this.file = null;
                    this.clearInputFile()
                    return;
                }

                // Check file size (max 5MB)
                
                else if (this.file.size > maxSize) {
                    this.$toasted.show('La taille du fichier ne doit pas dépasser 5MB.', this.ToastTabError);
                    this.file = null;
                    this.clearInputFile()
                    return;
                }else {
                    this.dialogLoadingFile = true
                    let formData = new FormData();
                    formData.append('cardid', this.file);
                    formData.append('token', this.tokenUserData);
                    Api().post('user/set-idcard', formData)
                        .then(response => {
                            this.dialogLoadingFile = false
                            if(response.data && response.data.ok===0) {
                                this.$toasted.show('Une erreur est survenue lors de la récupération de votre pièce d\'identité.', this.ToastTabError)
                            }else {
                                this.$toasted.show('Merci, pièce d\'identité envoyée avec succès.', this.ToastTabSucess)
                                 setTimeout(() => {
                                    this.$router.push('/kyc/thank')
                                }, 2000)
                                //this.showPassword = true;
                            }
                        }).catch(error => {
                            this.dialogLoadingFile = false
                            if (error.response && error.response.data && error.response.data.msg) {
                                this.$toasted.show(error.response.data.msg, this.ToastTabError);
                            } else {
                                this.$toasted.show('Une erreur est survenue lors de la récupération de votre pièce d\'identité', this.ToastTabError);
                            }
                         });
                    }
            },

            clearInputFile(){
                const fileInput = document.querySelector('input[type="file"]');
                if (fileInput) {
                    fileInput.value = '';
                }
            },

            checklink_to_set_user_password(token)
            {
                if (token) 
                {
                    let userData = { "token": token  }
                    Api().post('user/check-idcard-link', userData)
                    .then(response => {
                        console.log(':::::: upload idcard', response)
                        if(response.data && response.data.ok===0) {
                            this.$toasted.show('Lien invalide ou expiré.', this.ToastTabError)
                        }else {
                            this.isValidToken = true;
                        } 
                    }).catch(error => {
                        if (error.response && error.response.data && error.response.data.msg) {
                            //this.$toasted.show(error.response.data.msg, this.ToastTabError);
                            this.$toasted.show('Une erreur est survenue', this.ToastTabError);
                            this.isValidToken = false;
                             setTimeout(() => {
                                    this.$router.push('/')
                                }, 3000)
                        } else {
                            this.$toasted.show('Une erreur est survenue', this.ToastTabError);
                             setTimeout(() => {
                                    this.$router.push('/')
                                }, 3000)
                        }
                    });
                } 
                // else {
                //     this.$toasted.show('Le token est manquant', this.ToastTabError);
                // }
            },

        },

         watch : {
            showLoginForm(val) {
                if (val == false) {
                    if (store.state.isUserLoggedIn) {
                    this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
                    }
                }
            },
        },

        mounted() 
        {
          if (this.$store.state.isUserLoggedIn && this.$store.state.user!=null && this.$store.state.user!={}) {
                  window.scrollTo(0, 0);
                const params = new URLSearchParams(window.location.search);
                this.tokenUserData = params.get('token') //.replace(/[_]/g, '/')
                this.checklink_to_set_user_password(this.tokenUserData)
            } else {
                this.$toasted.show('Identifiez-vous pour utiliser le lien !', this.ToastTabError)
                this.showLoginForm = true
            }
        },
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/button.css";
@import "../../assets/css/devis_css.css";
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
    .list-boutons .link-btn {
        text-decoration: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .list-boutons .link-btn:hover {
        background: #ffa409;
        color: white;
    }








    .main {
        background-color: #FFFFFF;
        width: 500px;
        height: 350px;
        margin: 7em auto;
        border-radius: 1.5em;
        box-shadow: 0px 11px 35px 2px rgba(0, 0, 0, 0.14);
    }
    
    .sign {
        padding-top: 40px;
        color: #ffa409;
        font-family: 'Ubuntu', sans-serif;
        font-weight: bold;
        font-size: 23px;
    }
    
    .un {
    width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
    form.form1 {
        padding-top: 40px;
    }
    
    .pass {
            width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
   
    .un:focus, .pass:focus {
        border: 2px solid rgba(0, 0, 0, 0.18) !important;
        
    }
    
    .submit {
      cursor: pointer;
        border-radius: 5em;
        color: #fff;
        background: #ffa409;
        border: 0;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        padding-top: 10px;
        //font-family: 'Ubuntu', sans-serif;
        margin-left: 38%;
        font-size: 15px;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.04);
    }
    
    .forgot {
        text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
        color: #E1BEE7;
        padding-top: 15px;
    }
    
    // a {
    //     text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
    //     color: #E1BEE7;
    //     text-decoration: none
    // }
    
    @media (max-width: 600px) {
        .main {
            border-radius: 0px;
        }
    }

























    .main-mobile {
        background-color: #FFFFFF;
        width: auto;
        height: 350px;
        margin: 12em auto;
        border-radius: 1.5em;
        box-shadow: 0px 11px 35px 2px rgba(0, 0, 0, 0.14);
        //margin-top: 20px;
    }
    
    .sign-mobile {
        padding-top: 40px;
        color: #ffa409;
        font-family: 'Ubuntu', sans-serif;
        font-weight: bold;
        font-size: 23px;
    }
    
    .un-mobile {
    width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
    form.form1-mobile {
        padding-top: 40px;
    }
    
    .pass-mobile {
            width: 80%;
    color: rgb(38, 50, 56);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
    background: rgba(136, 126, 126, 0.04);
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    outline: none;
    box-sizing: border-box;
    border: 2px solid rgba(0, 0, 0, 0.02);
    margin-bottom: 50px;
    margin-left: 46px;
    text-align: center;
    margin-bottom: 27px;
    font-family: 'Ubuntu', sans-serif;
    }
    
   
    .un-mobile:focus, .pass-mobile:focus {
        border: 2px solid rgba(0, 0, 0, 0.18) !important;
        
    }
    
    .submit-mobile {
      cursor: pointer;
        border-radius: 5em;
        color: #fff;
        background: #ffa409;
        border: 0;
        padding-left: 40px;
        padding-right: 40px;
        padding-bottom: 10px;
        padding-top: 10px;
        //font-family: 'Ubuntu', sans-serif;
        margin-left: 35%;
        align-items: center;
        font-size: 15px;
        box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.04);
    }
    
    
    // a {
    //     text-shadow: 0px 0px 3px rgba(117, 117, 117, 0.12);
    //     color: #E1BEE7;
    //     text-decoration: none
    // }
    
    @media (max-width: 600px) {
        .main {
            border-radius: 0px;
        }
    }
        



  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}




.form-cni {
    background-color: #fff;
    padding: 1.5rem;
  }
  
  .form-cni .page {
    height: auto;
  }
.drop-container {
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  gap:10px;
  width:50%;
  padding:20px;
  border:2px dashed #000;
  border-radius:10px;
  background-color:#fefbf6;
  color:#000;
  cursor:pointer;
  -webkit-transition:background .2s ease-in-out,border .2s ease-in-out;
  transition:background .2s ease-in-out,border .2s ease-in-out
}
.drop-container:hover {
  background-color:#fbc162
}

.drop-container-mobile {
  display:-webkit-box;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  gap:10px;
  width:100%;
  padding:20px;
  border:2px dashed #000;
  border-radius:10px;
  background-color:#fefbf6;
  color:#000;
  cursor:pointer;
  -webkit-transition:background .2s ease-in-out,border .2s ease-in-out;
  transition:background .2s ease-in-out,border .2s ease-in-out
}
.drop-container-mobile:hover {
  background-color:#fbc162
}

.title-cni {
  color:#222245!important;
  font-size:25px;
  font-weight:700;
  text-align:center
}
.title-cni-invalid-link {
  color:rgb(248, 41, 41)!important;
  font-size:25px;
  font-weight:700;
  text-align:center;
  margin-top: 5%;
}
.title-cni-invalid-link-mobile {
  color:rgb(248, 41, 41)!important;
  font-size:25px;
  font-weight:700;
  text-align:center;
  margin-top: 35%;
}
.title-cni-mobile {
  color:#222245!important;
  font-size:25px;
  font-weight:700;
  text-align:center;
  margin-top: 15%;
}
.drop-title {
  color:#222245!important;
  font-size:20px;
  font-weight:700;
  text-align:center
}
.drop-subtitle {
  color:#222245!important;
  font-size:15px;
  font-weight:500;
  text-align:center
}
input[type=file] {
  width:350px;
  max-width:100%;
  color:#222245;
  padding:8px;
  background-color:#fff;
  border:1px solid #222245;
  border-radius:10px
}
input[type=file]:focus {
  outline-offset:2px
}
input[type=file]::file-selector-button {
  margin-right:8px;
  border:none;
  border-radius:10px;
  background-color:#f4ac39;
  padding:8px 12px;
  color:#000;
  font-size:15px;
  cursor:pointer
}
input[type=file]::file-selector-button:hover {
  background-color:#ffa409
}

</style>